<div class="transfer-container d-flex flex-column justify-content-between">
    <div class="header p-4">
        <div class="d-flex justify-content-start align-items-center" (click)="backToBeneficiarySelection()">
            <mat-icon fontIcon="arrow_back"></mat-icon>
            <span>Back</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-4">
            <div class="icon">
                <img src="assets/p2p.svg" alt="Logo" />
            </div>
            <h2>{{ data.selectedTransferType === transferType.INTRA_WALLET ? 'Intra-wallet Transfer' : 'Peer to Peer Transfer'}}</h2>
        </div>
    </div>

    <div class="receiver-details p-4 mx-4 -my-4">
        <div class="d-flex justify-content-between align-items-center">
            <span class="receiver-details-title">Receiver Details</span>
            <!-- <div class="toggle">
                <label>Save as beneficiary</label>
                <input type="checkbox" checked />
            </div> -->
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-2">
            <!-- <mat-icon svgIcon="user-img" class="profile-img"></mat-icon> -->
            <div *ngIf="recipientInfo">
                <p class="receiver-name d-flex justify-content-center">
                    {{ recipientInfo?.first_name?.[0] + '*'.repeat(recipientInfo.first_name.length - 2) + recipientInfo.first_name[recipientInfo.first_name.length - 1] }}
                    {{ recipientInfo?.last_name?.[0] + '*'.repeat(recipientInfo.last_name.length - 2) + recipientInfo.last_name[recipientInfo.last_name.length - 1] }}
                </p>
                <p class="receiver-phone d-flex justify-content-center">{{ recipientInfo.mobile }}</p>
            </div>
        </div>
    </div>

    <div class="wallet-container px-4 mt-4">
        <div class="wallet-section" [class.border-danger]="doesAmountExceedBalance || !isCurrencySame" [class.border]="doesAmountExceedBalance || !isCurrencySame">
            <div class="wallet-header d-flex justify-content-between align-items-center">
                <div class="wallet-title">{{ data.selectedTransferType === transferType.INTRA_WALLET ? 'From Wallet (Source wallet)' : 'Sender’s Wallet' }}</div>
                <div class="wallet-balance">Balance: {{ balance }}</div>
            </div>
            <div class="wallet-input-group">
                <div class="currency-select">
                    <!-- <img src="assets/home/united states.svg" alt="Flag Icon" class="flag-icon" /> -->
                    <app-value-field *ngIf="senderAccounts.length > 0; else sender" [editMode]="true">
                        <app-value-field-select
                            *ngIf="form.controls.senderCurrency"
                            [controlDisplayName]="'Send Currency'"
                            [control]="form.controls.senderCurrency"
                            appValueField="editField"
                            placeholder="Select currency"
                        >
                            <ng-template *ngFor="let account of senderAccounts" [appValueFieldOption]="account.currencies[0]">
                                <div class="d-flex align-items-center">
                                    <img
                                        [src]="'/assets/currency-flags/' + account.currencies[0] + '-flag.svg'"
                                        [alt]="account.currencies[0]"
                                        style="width: 15px; height: 15px"
                                        class="rounded-circle me-1"
                                    />
                                    <span style="font-size: 16px; margin-right: 10px">{{ account.currencies[0] }}</span>
                                </div>
                            </ng-template>
                        </app-value-field-select>
                    </app-value-field>

                    <ng-template #sender>
                        <span>{{ senderAccounts[0]?.currencies?.[0] }}</span>
                        <i class="fas fa-caret-down text-success"></i>
                    </ng-template>
                </div>
                <input type="number" class="form-control amount-input" [formControl]="form.controls.sendAmount" />
            </div>
        </div>

        <div class="arrow-icon">
            <mat-icon class="text-success">expand_more</mat-icon>
        </div>

        <div class="wallet-section" [class.border-danger]="!isCurrencySame" [class.border]="!isCurrencySame">
            <div class="wallet-header">
                <span class="wallet-title text-orange">{{ data.selectedTransferType === transferType.INTRA_WALLET ? 'To  Wallet (Destination wallet)' : 'Receiver’s Wallet' }}</span>
            </div>
            <div class="wallet-input-group">
                <div class="currency-select">
                    <!-- <img src="assets/home/united states.svg" alt="Flag Icon" class="flag-icon" /> -->
                    <app-value-field *ngIf="recipientAccounts.length > 0; else recieverSingleAccount" [editMode]="true">
                        <app-value-field-select
                            *ngIf="form.controls.receiverCurrency"
                            [controlDisplayName]="'Receive Currency'"
                            [control]="form.controls.receiverCurrency"
                            appValueField="editField"
                            placeholder="Select currency"
                        >
                            <ng-template *ngFor="let account of recipientAccounts" [appValueFieldOption]="account.currencies[0]">
                                <div class="d-flex align-items-center">
                                    <img
                                        [src]="'/assets/currency-flags/' + account.currencies[0] + '-flag.svg'"
                                        [alt]="account.currencies[0]"
                                        style="width: 15px; height: 15px"
                                        class="rounded-circle me-1"
                                    />
                                    <span style="font-size: 16px; margin-right: 10px">{{ account.currencies[0] }}</span>
                                </div>
                            </ng-template>
                        </app-value-field-select>
                    </app-value-field>

                    <ng-template #recieverSingleAccount>
                        <span>{{ recipientAccounts[0]?.currencies?.[0] }}</span>
                        <i class="fas fa-caret-down text-success"></i>
                    </ng-template>
                </div>
                <input type="number" class="form-control amount-input" [value]="form.controls.receiveAmount.value" [disabled]="true" />
            </div>
        </div>

        <div *ngIf="doesAmountExceedBalance" class="error-message" style="font-size: 13px">Please do not enter value greater than your balance</div>
        <div *ngIf="!isCurrencySame && !doesAmountExceedBalance" class="error-message" style="font-size: 13px">You can only transfer money between accounts using the same currency.</div>
    </div>

    <div class="exchange-rate px-4" *ngIf="exchangeDetails">
        <label>Exchange rate</label>
        <p>
            1 {{ form.get('senderCurrency')?.value }} = {{ exchangeDetails?.exchange_rate }}{{ form.get('receiverCurrency')?.value }}
        </p>
    </div>

    <textarea class="m-4 my-2 form-control w-auto" placeholder="Add a note (Optional)" [formControl]="form.controls.note"></textarea>

    <div class=" d-flex justify-content-start align-items-center p-4">
        <button
            mat-raised-button
            class="btn-primary rounded-pill me-2"
            [class.btn-primary-disabled]="!isCurrencySame || doesAmountExceedBalance || !form.valid"
            [class.button-spinner]="loading"
            [disabled]="!isCurrencySame || doesAmountExceedBalance || loading || !form.valid"
            (click)="continueToPeerToPeerConfirmation()"
        >
            {{ loading ? '' : 'View Summary' }}
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="backToBeneficiarySelection()">Cancel</button>
    </div>
</div>
